import MajorsApi from '../../api/MajorsApi'

export const getAllMajors = () => {
  return async (dispatch) => {
    
    try {
      const api = new MajorsApi();

      const majors = parseMajors( await api.list() );
      
      dispatch(setAllMajors(majors))

    } catch (error) {
      console.error('error',error)
    }

  }
}

/**
 * Parse the API majors list for its use throughout the App.
 * @param {Array} list Majors list from the API.
 * @returns {Array}
 */
const parseMajors = (list) => (
  list.map( ({ id, nombre }) => ({ value: id, label: nombre }) )
)


const setAllMajors = payload => ({ type: 'majors/setAll', payload })